import {FilterCollectionStore, SyncedRemoteCollectionStore, SortCollectionStore, StoreBuilder} from '@softline/core';
import {Checkpunkt} from '../types/checkpunkt';

const collectionStore = SyncedRemoteCollectionStore.create<Checkpunkt>();

export const CheckpunkteStore = new StoreBuilder(collectionStore)
  .add(FilterCollectionStore.create<Checkpunkt>())
  .add(SortCollectionStore.create<Checkpunkt>())
  .value;
